





import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Vue fade transition
 */
@Component
export default class TransitionFade extends Vue {}
